import { UserInformation } from "../../interfaces";
import localStorageHelper from "../localStorageHelper";

const LOCALSTORAGE_USER_KEY = "uid";

const userHelper = {
  // Save in localStorage
  saveUser(data: UserInformation): void {
    localStorageHelper.save(LOCALSTORAGE_USER_KEY, data);
  },

  // Get from localStorage
  getUser(): UserInformation | null {
    const resp = localStorageHelper.get<UserInformation>(LOCALSTORAGE_USER_KEY);
    return resp;
  },

  parseUserJwt(token: string): any {
    if (!token) return null;
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );

    return JSON.parse(jsonPayload);
  },
};

export default userHelper;
